<template>
  <v-app id="app" class="mk-app">
    <v-app-bar color="primary" class="mk-toolbar">
      <div class="mk-toolbar-justify mk-toolbar-desktop">
        <router-link to="/">
          <v-btn text>{{
            $vuetify.breakpoint.smAndDown ? "Heute" : "Wer ist der SVW"
          }}</v-btn>
        </router-link>
        <router-link to="/ourStory">
          <v-btn text>{{
            $vuetify.breakpoint.smAndDown ? "Geschichte" : "Unsere Geschichte"
          }}</v-btn>
        </router-link>
        <router-link to="/coach">
          <v-btn text>{{
            $vuetify.breakpoint.smAndDown ? "Betreuung" : "Trainiert & Betreut"
          }}</v-btn>
        </router-link>
      </div>
    </v-app-bar>

    <v-content class="mk-content">
      <div class="mk-content-background">
        <router-view />
      </div>
    </v-content>
  </v-app>
</template>
<style>
html,
body {
  height: 100%;
  width: 100%;
  overflow-scrolling: unset;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}

.mk-app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.mk-toolbar {
  /* fix for IE11 */
  min-height: 64px;
  flex-grow: 0 !important;
}
.mk-toolbar-justify {
  overflow: hidden;
  flex-grow: 100;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  flex-wrap: nowrap;
  justify-content: center;
}

.mk-content {
  flex-grow: 1;
  width: 100%;
}
.mk-content-background {
  display: flex;
  min-height: 100%;
  background-color: #707070;
  background-image: url("svw-90-jahre-logo-0.8.jpg");
  background-position-x: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: contain;
  background-position-y: 20px;
  overflow: auto;
}

@media only screen and (max-width: 800px) {
}
</style>
<script>
export default {
  name: "app",
  data: () => ({
    menuVisible: false,
    group: null
  }),
  watch: {
    group() {
      this.menuVisible = false;
    }
  }
};
</script>
